import type { ElementRef, ComponentPropsWithoutRef } from "react";

import { forwardRef } from "react";

export const IconTeam = forwardRef<
  ElementRef<"svg">,
  ComponentPropsWithoutRef<"svg">
>((props, ref) => {
  return (
    <svg
      ref={ref}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.83333 17.0833V16C6.0975 10.8442 13.9025 10.8442 14.1667 16V17.0833M2.5 7.83333C2.5 5.96667 2.5 5.03333 2.86333 4.32C3.18291 3.69282 3.69282 3.18291 4.32 2.86333C5.03333 2.5 5.96667 2.5 7.83333 2.5H12.1667C14.0333 2.5 14.9667 2.5 15.68 2.86333C16.3072 3.18291 16.8171 3.69282 17.1367 4.32C17.5 5.03333 17.5 5.96667 17.5 7.83333V12.1667C17.5 14.0333 17.5 14.9667 17.1367 15.68C16.8171 16.3072 16.3072 16.8171 15.68 17.1367C14.9667 17.5 14.0333 17.5 12.1667 17.5H7.83333C5.96667 17.5 5.03333 17.5 4.32 17.1367C3.69282 16.8171 3.18291 16.3072 2.86333 15.68C2.5 14.9667 2.5 14.0333 2.5 12.1667V7.83333ZM12.0833 7.70833C12.0833 8.26087 11.8638 8.79077 11.4731 9.18147C11.0824 9.57217 10.5525 9.79167 10 9.79167C9.44747 9.79167 8.91756 9.57217 8.52686 9.18147C8.13616 8.79077 7.91667 8.26087 7.91667 7.70833C7.91667 7.1558 8.13616 6.62589 8.52686 6.23519C8.91756 5.84449 9.44747 5.625 10 5.625C10.5525 5.625 11.0824 5.84449 11.4731 6.23519C11.8638 6.62589 12.0833 7.1558 12.0833 7.70833Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
IconTeam.displayName = "IconTeam";
